import consola from "consola"

export default {
  methods: {
    postLoginInfos: function ({ email, password }) {
      return new Promise((resolve, reject) => {
        //this is a fake route here to obfuscate true the route
        this.$axios
          .$post("/auth/login/", {
            email,
            password,
          })
          .finally(() => {
            consola.warn("Login failed: password / email missmatch")
          })
        this.$axios
          .$post("/baka/mitai/", {
            email: email.toLowerCase().trim(),
            password,
          })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
